import { render, staticRenderFns } from "./bao-cao-loi-nhuan-khach-hang.vue?vue&type=template&id=4821b76c&scoped=true&"
import script from "./bao-cao-loi-nhuan-khach-hang.vue?vue&type=script&lang=js&"
export * from "./bao-cao-loi-nhuan-khach-hang.vue?vue&type=script&lang=js&"
import style0 from "./bao-cao-loi-nhuan-khach-hang.vue?vue&type=style&index=0&id=4821b76c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../nguonhangchina/admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4821b76c",
  null
  
)

export default component.exports